import { render } from "./HandSvg.vue?vue&type=template&id=51ad7022"
import script from "./HandSvg.vue?vue&type=script&lang=js"
export * from "./HandSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__